module.exports = __webpack_public_path__ + "img/santafegolf-logotipo-positivo.ecdac29c.svg";